export default "__VITE_ASSET__J2rWqPiO__"